import { FormGroup, FormSection, TextInput } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils/';
import { translateKey } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils/';

export interface IWaitingTimes {
    applicationWaitingTime: number | null;
    treatmentWaitingTime: number | null;
}

export interface IWaitingTimesProps {
    errorPrefix?: string;
    errors?: ValidationErrors;
    onChange: (key: keyof IWaitingTimes, value: IWaitingTimes[keyof IWaitingTimes]) => void;
    onDoValidate?: (key: keyof IWaitingTimes) => void;
    waitingTimes: IWaitingTimes;
}

export function WaitingTimes(props: IWaitingTimesProps) {
    return (
        <FormSection title={translateKey('waitingTime.waitingTimes')}>
            <FormGroup
                hasErrors={hasError('treatmentWaitingTime')}
                label={translateKey('waitingTime.treatmentWaitingTime')}
            >
                <TextInput
                    error={getErrorMessage('treatmentWaitingTime')}
                    onBlur={() => handleValidateOne('treatmentWaitingTime')}
                    onChange={(e) =>
                        props.onChange('treatmentWaitingTime', e.target.value ? parseInt(e.target.value, 10) : null)
                    }
                    placeholder={translateKey('waitingTime.total')}
                    value={
                        props.waitingTimes.treatmentWaitingTime
                            ? props.waitingTimes.treatmentWaitingTime.toString()
                            : ''
                    }
                />
            </FormGroup>
            <FormGroup
                hasErrors={hasError('applicationWaitingTime')}
                label={translateKey('waitingTime.applicationWaitingTime')}
            >
                <TextInput
                    error={getErrorMessage('applicationWaitingTime')}
                    onBlur={() => handleValidateOne('applicationWaitingTime')}
                    onChange={(e) =>
                        props.onChange('applicationWaitingTime', e.target.value ? parseInt(e.target.value, 10) : null)
                    }
                    placeholder={translateKey('waitingTime.total')}
                    value={
                        props.waitingTimes.applicationWaitingTime
                            ? props.waitingTimes.applicationWaitingTime.toString()
                            : ''
                    }
                />
            </FormGroup>
        </FormSection>
    );

    function hasError(key: keyof IWaitingTimes) {
        const errorKey = getErrorKey(key);

        return props.errors?.has(errorKey);
    }

    function getErrorMessage(key: keyof IWaitingTimes) {
        const errorKey = getErrorKey(key);

        return getValidationErrorTranslation(props.errors?.get(errorKey));
    }

    function getErrorKey(key: keyof IWaitingTimes) {
        return `${props.errorPrefix ?? ''}${key}`;
    }

    function handleValidateOne(key: keyof IWaitingTimes) {
        if (props.onDoValidate) {
            props.onDoValidate(key);
        }
    }
}
